import { serviceOptions } from 'api';
const downloadBlob = async (url, filename, method = 'GET', data = undefined) => {
  const result = await serviceOptions.axios?.request({
    method,
    url,
    responseType: 'blob',
    data
  });
  const blob = await result?.data;
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.setAttribute('download', filename);
  a.click();
};
export default downloadBlob;